import { unstable_cache } from 'next/cache'

const REVALIDATE_INTERVAL_SECONDS = 600 // 10 minutes

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

interface OctopusFetchOptions {
  method?: HttpMethod
  body?: Record<string, any> | FormData
  params?: Record<string, any>
  headers?: HeadersInit
}

interface AuthenticatedFetchOptions {
  method?: HttpMethod
  body?: Record<string, any> | FormData
  params?: Record<string, any>
}

const performOctopusFetch = async (url: string, options: OctopusFetchOptions = {}) => {
  const { method = 'GET', body, headers = {} } = options

  const isFormData = body instanceof FormData
  const fetchHeaders: HeadersInit = {
    ...headers,
  }

  if (!isFormData && body) {
    fetchHeaders['Content-Type'] = 'application/json'
  }

  const res = await fetch(url, {
    method,
    headers: fetchHeaders,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  })

  if (!res.ok) {
    console.error('OCTOPUS_FETCH_ERROR:', res)
    throw new Error(`Failed to fetch from Octopus: ${res.status} ${res.statusText}`)
  }

  return res.json()
}

export const fetchFromOctopusAuthenticated = async (
  endpoint: string,
  authToken: string,
  options: AuthenticatedFetchOptions = {},
) => {
  const { method = 'GET', body, params } = options

  const url = `${process.env.OCTOPUS_URL}/api/v1/${endpoint}?envCode=${process.env.NEXT_PUBLIC_OCTOPUS_ENV_CODE}${params ? `&${new URLSearchParams(params).toString()}` : ''}`

  return performOctopusFetch(url, {
    method,
    body,
    headers: {
      Authorization: authToken,
    },
  })
}

export const fetchFromOctopusPublic = async (endpoint: string, params?: Record<string, any>) => {
  const url = `${process.env.OCTOPUS_URL}/api/v1/${endpoint}?envCode=${process.env.NEXT_PUBLIC_OCTOPUS_ENV_CODE}${params ? `&${new URLSearchParams(params).toString()}` : ''}`

  return performOctopusFetch(url, {
    headers: {
      Authorization: `Bearer ${process.env.OCTOPUS_BEARER_TOKEN}`,
    },
  })
}

export const fetchFromOctopusPublicCached = unstable_cache(fetchFromOctopusPublic, ['octopus-data'], {
  revalidate: REVALIDATE_INTERVAL_SECONDS,
  tags: ['octopus'],
})

export const getTldFromEnvCode = (envCode: string) => {
  if (envCode === 'en') return 'com'
  if (envCode === 'ua') return 'com.ua'
  return envCode
}
